import {checkAnswers} from '../api';
import {getPatternsWithFillInfo} from './patterns-with-fill-info';

export const findFilledPatterns = async(puzzleDetail,cellVals)=>{
   
    if(!(puzzleDetail && puzzleDetail.puzzle)) return [];

    const puzzleId = puzzleDetail.puzzle.puzzleId;
    const patterns = puzzleDetail.puzzle.patterns;   

    const patternsWithFillInfo = getPatternsWithFillInfo(patterns,cellVals);
    
    const patternsFilled = patternsWithFillInfo.filter(p=>p.isPatternFilled).map(p=>({pattern:p.pattern,word:p.word}));

    const correctPatterns = [];

    const answers = patternsFilled.map(p=>{
        const {row,col,direction} = p.pattern;
        const {word} = p;

        return {puzzleId,word,row,col,direction};
    });

    const results = await checkAnswers(answers);

    //console.log('check answer results',results);

    for(let p of patternsFilled){
        
        const {row,col,direction} = p.pattern;
        const {word} = p;

        const result = results.find(r=>{
            return word === r.pattern.word && row === r.pattern.row && col === r.pattern.col && direction === r.pattern.direction;
        });

        if(result && result.isCorrect){
            correctPatterns.push(p);
        }       
      
    }

    return correctPatterns;

};

export const getRestoredCellVals =  (puzzleDetail)=>{               

    let result = {};

    if(!(puzzleDetail && puzzleDetail.puzzle && puzzleDetail.puzzle.puzzleId)) {
        //console.log('returned from restore cell vals');
        return result;
    }        

    const savedCellVals = localStorage.getItem(`puzzle_${puzzleDetail.puzzle.puzzleId}`);
    if(savedCellVals){
        try{
    

            result = JSON.parse(savedCellVals);              
                            
            
        }catch(e){
            console.log('Error on parsing saved cell vals!',e);

        }
    }

    return result;

};